<template>
  <path
    d="M21 18.0003C21.55 18.0003 22 17.5503 22 17.0003V11.0003C22 10.4503 21.55 10.0003 21 10.0003C20.45 10.0003 20 10.4503 20 11.0003V17.0003C20 17.5503 20.45 18.0003 21 18.0003ZM20 22.0003H22V20.0003H20V22.0003ZM4.40999 22.0003H18V11.0003C18 9.34026 19.34 8.00026 21 8.00026H22V4.41026C22 3.52026 20.92 3.07026 20.29 3.70026L3.70999 20.2903C3.07999 20.9203 3.51999 22.0003 4.40999 22.0003Z"
  />
</template>
